const e = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "_starOrbitalTrackAddress",
        type: "address"
      }
    ],
    name: "ContractSettingUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_starArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_successPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_failPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "string[]",
        name: "_failReasonArray",
        type: "string[]"
      }
    ],
    name: "PlanetOwnerDetachPlanetSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_starArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_successPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_failPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "string[]",
        name: "_failReasonArray",
        type: "string[]"
      }
    ],
    name: "RenewRentingOrbitalTrackSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "_starId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_successPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_failPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "string[]",
        name: "_failReasonArray",
        type: "string[]"
      }
    ],
    name: "RentingOrbitalTrackSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "_starId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_successPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_failPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "string[]",
        name: "_failReasonArray",
        type: "string[]"
      }
    ],
    name: "StarOwnerAttachOwnPlanetSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_starArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_successPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_failPlanetArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "string[]",
        name: "_failReasonArray",
        type: "string[]"
      }
    ],
    name: "StarOwnerDetachPlanetSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_starIdArray",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_planetIdArray",
        type: "uint256[]"
      }
    ],
    name: "planetOwnerDetachPlanet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_starIdArray",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_planetIdArray",
        type: "uint256[]"
      }
    ],
    name: "renewRentingOrbitalTrack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_starId",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "_planetIdArray",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_inviteGroupIdArray",
        type: "uint256[]"
      }
    ],
    name: "rentingOrbitalTrack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_starId",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "_planetIdArray",
        type: "uint256[]"
      }
    ],
    name: "starOwnerAttachOwnPlanet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_starIdArray",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_planetIdArray",
        type: "uint256[]"
      }
    ],
    name: "starOwnerDetachPlanet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_starOrbitalTrackAddress",
        type: "address"
      }
    ],
    name: "updateContractSetting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=ronin-orbital-track-caller.json.js.map
